import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import find from 'lodash/find'

import * as CONSTANTS from '../../constants'
import SubmitProjectForm from '../../form/submit-project'
import { saveButton } from '../../helper/button'
import { FONTS } from '../../../../constants'
import { Button } from '../../../buttons'

const ppsProjectType = ['FIXFEE', 'TIME_MATERIAL', 'SUPPORT', 'IAM_PRODUCT', 'CLOUD']

export const ToggleButton = class extends React.Component {
  state={ showSaveSnapshot: false }

  clickSave = () => {
    this.setState({
      submit_remark: '',
      showSaveSnapshot: !this.state.showSaveSnapshot,
    })
  }

  saveSnapshot = () => {
    const saveSnapshot = get(this.props, 'saveSnapshot')
    saveSnapshot({ remark: this.state.submit_remark })
    this.clickSave()
  }

  render() {
    const { $canSeeOverviewStandard, $canSeeOverviewActual } = this.props
    const { clickToggleButton, activeToggle } = this.props
    const projectByID = get(this.props, 'projectByID')
    const projectType = get(projectByID, 'project_type')
    const approveStatus = get(projectByID, 'project_approve_status')
    // const projectStatus = get(projectByID, 'project_status')
    const clickSubmitProject = get(this.props, 'clickSubmitProject')
    const selectedVersion = get(this.props, 'selectedVersion')
    const projectID = projectByID ? projectByID._id : ''
    // const canShow = projectType !== CONSTANTS.SUPPORT
    const canGoToPPS = ppsProjectType.includes(projectType)
    const canSubmit =
    (approveStatus === CONSTANTS.NONSUMMIT || approveStatus === CONSTANTS.REJECTED)
    && (find(get(this.props, 'project_managers'), {
      _id: get(this.props, 'id'),
    }))

    return (
      <Wrapper>
        <SubmitProjectForm
          open={ this.state.showSaveSnapshot }
          status={ 'Save Version' }
          button={ saveButton(
            () => this.saveSnapshot(),
            () => this.setState({ showSaveSnapshot: !this.state.showSaveSnapshot }))
          }
          handleInput={ (e) => this.setState({ submit_remark: e.target.value }) }
          toggle={ () => this.setState({ showSaveSnapshot: !this.state.showSaveSnapshot }) }
        />
        <TabWrapper>
          <ButtonWrapper>
            <Toggle
              active={ activeToggle === 1 }
              style={ {
                borderRadius: !($canSeeOverviewStandard || $canSeeOverviewActual) ? '4px' : '4px 0px 0px 4px',
              } }
              onClick={ () => clickToggleButton(1) }
            >
            Overview (PM)
            </Toggle>
            { $canSeeOverviewStandard &&
            <Toggle
              active={ activeToggle === 2 }
              onClick={ () => clickToggleButton(2) }
            >
            Display Standard Costs
            </Toggle>
            }
            { $canSeeOverviewActual &&
            <Toggle
              active={ activeToggle === 3 }
              style={ { borderRadius: '0px 4px 4px 0px' } }
              onClick={ () => clickToggleButton(3) }
            >
            Display Actual Costs
            </Toggle>
            }
          </ButtonWrapper>
          { canGoToPPS &&
          <Link
            to={ {
              pathname: `/project_profit_sheet/overview/${projectID}`,
              state: { header: 'Project Profit Sheet' },
            } }
          >
            <PPSButton>
              Go to PPS
            </PPSButton>
          </Link>
          }
        </TabWrapper>
        { activeToggle === 1 && selectedVersion === '' &&
        <ButtonWrapper style={ { justifyContent: 'flex-end' } }>
          { canSubmit &&
          <Button
            theme='#28a745'
            width='120px'
            height='26px'
            onClick={ () => clickSubmitProject() }
          >
            Submit Project
          </Button>
          }
          <Button
            theme='#28a745'
            width='110px'
            height='26px'
            style={ { marginLeft: 12 } }
            onClick={ () => this.clickSave() }
          >
            Save Version
          </Button>
        </ButtonWrapper>
        }
      </Wrapper>
    )
  }
}

ToggleButton.propTypes = {
  $canSeeOverviewStandard: PropTypes.bool,
  $canSeeOverviewActual: PropTypes.bool,
  clickToggleButton: PropTypes.func,
  activeToggle: PropTypes.number,
}
ToggleButton.defaultProps = {
  $canSeeOverviewStandard: false,
  $canSeeOverviewActual: false,
  clickToggleButton: () => {},
  activeToggle: 1,
}
const Toggle = styled.div`
  width: auto;
  height: 27px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${p => (p.active ? '#D44B49' : '#FFFFFF')};
  color: ${p => (p.active ? '#FFFFFF' : '#808080')};
  border: ${p => (p.active ? '1px solid #AD2624;' : '1px solid #F2F2F2;')};
  font-family: ${p => (p.active ? FONTS.GOTHAM_BOLD : FONTS.GOTHAM)};
  font-size: ${FONTS.SMALL_SIZE};
  padding: 8px;
  cursor: pointer;

  :hover {
    ${p => !p.active && `
      background: rgba(212, 75, 73, 0.08);
      border: 1px solid #AD2624;
      color: #D44B49;
    `}
  }
`

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px;
`

const ButtonWrapper = styled(Wrapper)`
  flex: 1;
  justify-content: flex-start;
  padding: 0;

  :nth-child(1) {
    margin-right: 16px;
  }
`

const TabWrapper = styled.div`
  display: flex;
  align-items: center;
`

const PPSButton = styled.div`
  width: 85px;
  height: 27px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #2F80ED;
  border: 1px solid #004AAE;
  border-radius: 4px;
  color: #FFFFFF;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  padding: 8px;
  cursor: pointer;

  :hover {
    background: #333333;
  }
`



// WEBPACK FOOTER //
// ./src/components/project-information/table/table-overview/toggle-button.js